/**
 * Creation-order pin numbering shared by the extension canvases
 * (PinAnnotationCanvas, PassiveHighlightsLayer) and the team-review
 * sidebar (useCaptureSession -> oq:render-pins).
 *
 * Pin marker numbers must reflect CAPTURE ORDER: the first captured pin is 1
 * and keeps that number as later pins are added. The issue lists these
 * surfaces work from are NOT in capture order (GET /api/issues returns
 * desc(createdAt); the extension prepends new pins), so numbering by array
 * index reversed on every capture — see incident 2026-06-11 (team review:
 * capturing a second issue made the NEW pin number 1).
 */
function creationTime(createdAt) {
    if (!createdAt)
        return Infinity;
    const t = Date.parse(createdAt);
    return Number.isNaN(t) ? Infinity : t;
}
/**
 * Map item id -> display number (1..N) in creation order (oldest = 1).
 * Ties and missing/invalid timestamps keep their input order (stable sort),
 * so numbering never flickers between renders of the same list.
 */
export function pinNumbersByCreation(items) {
    const ordered = items
        .map((item, index) => ({ id: item.id, index, time: creationTime(item.createdAt) }))
        .sort((a, b) => (a.time - b.time) || (a.index - b.index));
    const numbers = new Map();
    ordered.forEach((entry, position) => {
        numbers.set(entry.id, position + 1);
    });
    return numbers;
}
//# sourceMappingURL=pinNumbering.js.map